@import url("./sellalong-cta.css");

.sellalong-cta-link {
  color: #000;
  font-family: "Recoleta-Regular", serif;
  font-size: 18px;
  font-weight: normal;
  line-height: 26px;
  margin-bottom: 16px;
}

.sellalong-cta-action {
  border-bottom: 1px solid #52a69b;
  color: #52a69b;
  font-family: sans-serif;
  font-size: 11px;
  font-weight: normal;
  letter-spacing: 1px;
  margin-left: 4px;
  padding-bottom: 1px;
  text-transform: uppercase;
}

.sellalong-cta-action:hover {
  border-bottom-color: #014c43;
  color: #014c43;
}
